import cn from 'classnames';
import { twMerge } from 'tailwind-merge';

const Header = ({
  icon,
  title,
  subtitle,
  className,
  titleStyle,
}: {
  icon: React.ReactNode;
  title: string;
  className: string;
  titleStyle?: string;
  subtitle?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        'relative flex justify-center items-center w-full h-[80px] rounded-[12px] md:h-[80px]',
        className,
      )}
    >
      <div>
        <div>{icon}</div>
      </div>
      {/* Title compare */}
      <div className="ml-[15px] flex flex-col leading-[1.3rem]">
        <p
          className={cn(
            'inline cursor-text font-medium text-[16px] md:text-[22px]',
            titleStyle,
          )}
        >
          {title}
        </p>
        {subtitle && <span className="text-gray-200">{subtitle}</span>}
      </div>
    </div>
  );
};

const Content = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) => {
  return (
    <div className={twMerge(cn('px-4 flex flex-col grow justify-around', className))}>
      {children}
    </div>
  );
};

const SquaredBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col w-full min-h-[300px] bg-white border border-accent rounded-[16px] p-[13px] pl-[11px]">
      {children}
    </div>
  );
};

SquaredBox.Header = Header;

SquaredBox.Content = Content;

export default SquaredBox;
